export default __webpack_public_path__ + "static/media/explosion-proof.0cc421a8.png";